import { useState } from "react";
import { HelpCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { t } from "@/i18n";

const REASON = { missing: "Missing detail", conflicting: "Conflicting sources", low_quality: "Low-quality source" };

export function ClarificationsPanel({ sop, api, reload }) {
  const [answers, setAnswers] = useState({});
  const open = (sop.clarifications || []).filter((c) => !c.answer);
  const done = (sop.clarifications || []).filter((c) => c.answer);
  if (sop.status === "processing") return null;

  const submit = async () => {
    const list = Object.entries(answers).filter(([, a]) => a.trim()).map(([id, answer]) => ({ id, answer }));
    try {
      await api.post(`/sops/${sop.id}/clarify`, { answers: list });
      toast.success(t("Thanks — redrafting with your answers"));
      setAnswers({});
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="card stack-sm" data-testid="clarifications-panel">
      <p className="mono-label flex items-center gap-2"><HelpCircle size={13} /> {t("Owner clarifications")}</p>
      {open.length === 0 && <p className="text-sm muted flex gap-2" data-testid="clarifications-empty"><CheckCircle2 size={16} className="text-[var(--accent-primary)]" /> {t("No open questions.")}</p>}
      {open.map((c, i) => (
        <div key={c.id} className="stack-sm" data-testid={`clarification-item-${i}`}>
          <span className="chip chip-info">{t(REASON[c.reason] || "Clarify")}</span>
          <p className="text-sm font-semibold">{c.question}</p>
          <textarea className="field text-sm min-h-[64px]" value={answers[c.id] || ""} onChange={(e) => setAnswers({ ...answers, [c.id]: e.target.value })} placeholder={t("Your answer…")} data-testid={`clarification-answer-${i}`} />
        </div>
      ))}
      {open.length > 0 && (
        <button className="btn btn-primary w-full" onClick={submit} disabled={!Object.values(answers).some((a) => a.trim())} data-testid="clarifications-submit-button">{t("Submit answers & redraft")}</button>
      )}
      {done.length > 0 && <p className="text-xs faint">{t("Answered clarifications included in the SOP: {n}", { n: done.length })}</p>}
    </div>
  );
}
